import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';

const RadioButton = (props) => {
  const { onChange, name, option1, option2 } = props;
  return (
    <FormGroup check inline>
      <div>
        <Label>
          <Input 
            type="radio" 
            name={name} 
            value={option1.value} 
            onChange={onChange}
            checked={option1.checked} />{' '}
          Asc
        </Label>
      </div>

      <div>
        <Label>
          <Input 
            type="radio" 
            name={name} 
            value={option2.value} 
            onChange={onChange} 
            checked={option2.checked} />{' '}
          Desc
        </Label>
      </div>
    </FormGroup>
  );
};

RadioButton.propTypes = {
  option1: PropTypes.shape({
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired
  }),
  option2: PropTypes.shape({
    value: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired
  }),
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
};

export default RadioButton;